import styled from 'styled-components';
import { UserBadgeProps } from './userBadge.types';

function getFontSize(size: UserBadgeProps['size']) {
  switch (size) {
    case 'large':
      return '60px';
    case 'small':
      return '11px';
    default:
      return '11px';
  }
}

function getBorderWidth(size: UserBadgeProps['size']) {
  switch (size) {
    case 'large':
      return '4px';
    case 'small':
      return '2px';
    default:
      return '2px';
  }
}

function getDimensions(size: UserBadgeProps['size']) {
  switch (size) {
    case 'large':
      return {
        width: '120px',
        height: '120px',
      };
    case 'small':
      return {
        width: '24px',
        height: '24px',
      };
    default:
      return {
        width: '24px',
        height: '24px',
      };
  }
}

function getRadius(size: UserBadgeProps['size']) {
  switch (size) {
    case 'large':
      return '60px';
    case 'small':
      return '24px';
    default:
      return '24px';
  }
}

export const Container = styled.div<{
  $color: UserBadgeProps['color'];
  $enableShadows: UserBadgeProps['enableShadows'];
  $size: UserBadgeProps['size'];
}>`
  border-radius: ${({ $size }) => getRadius($size)};
  background-color: ${({ theme: { color } }) => color.ui6};
  box-sizing: border-box;
  border-style: solid;
  border-color: ${({ $color, theme: { color } }) => ($color ? $color : color.ui2)};
  border-width: ${({ $size }) => getBorderWidth($size)};
  ${({ $size }) => getDimensions($size)};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  filter: ${({ $enableShadows }) =>
    $enableShadows ? 'drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25))' : 'none'};
`;

export const Initials = styled.p<{ $size: UserBadgeProps['size'] }>`
  ${({ theme: { font } }) => font.t4};
  font-size: ${({ $size }) => getFontSize($size)};
  color: ${({ theme: { color } }) => color.ui2};
`;

export const ProfilePhoto = styled.img`
  width: 100%;
  height: 100%;
`;
